<h2 id="title" class="heading-01-bold">Hola, {{ this.value }}</h2>
<h2 id="title" class="heading-02-semi-bold">Mucho más que mudarte</h2>
<p class="paragraph-01-regular">
  Se ingresa a la propiedad y a la izquierda ingresamos a la cocina completa con
  espacio para una pequeña mesa con artefactos a gas y ventilación natural.
  Lavadero separado, con pileta de lavar, conexión para lavarropas y
  termotanque. Living comedor cómodo que permite una distribución sencilla del
  mobiliario y cuenta con una ventana de piso a techo.
</p>
<qr-input
  id="input"
  [config]="inputString"
  (valueChange)="inputChange($event)"
></qr-input>

<p class="paragraph paragraph-01-regular">
  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed id eros eu nisl
  scelerisque tincidunt. Pellentesque lacinia accumsan tincidunt. Etiam nisl ex,
  commodo vel lacus sit amet, auctor suscipit enim. Nunc ultricies elementum
  lacinia. Cras augue eros, aliquam quis orci sit amet, sodales vehicula dui.
  Nulla at gravida erat, et auctor eros. Integer finibus nisi iaculis fringilla
  pretium.
</p>

<p class="paragraph paragraph-01-regular">
  Morbi magna enim, cursus non tempor id, ultricies quis erat. Donec aliquet,
  ante in tincidunt tempus, metus dui placerat dui, vehicula ullamcorper est
  justo in purus. Nam sed venenatis augue. Curabitur et odio libero. Suspendisse
  aliquet tristique nunc at condimentum. Sed vel finibus velit, ut vulputate
  nisi. Ut lorem nisi, suscipit et pharetra vitae, egestas et ipsum. Aenean id
  ante vehicula, consequat leo quis, tempus eros. Maecenas ultrices ac ipsum eu
  semper. Etiam eget diam mauris. Maecenas dignissim velit et nisl dapibus, sed
  sodales felis aliquam. Integer vel neque sed mauris pellentesque suscipit sit
  amet auctor felis. Vivamus a libero in eros facilisis molestie quis eget
  massa. Praesent eleifend turpis a ex sollicitudin convallis. Maecenas gravida
  volutpat magna eget volutpat. Aenean nec turpis placerat, blandit nibh id,
  posuere nulla.
</p>

<p class="paragraph paragraph-01-regular">
  Sed at ultrices enim. Donec nec ligula non enim viverra laoreet at vitae
  velit. Phasellus congue, mauris nec dictum iaculis, mauris nulla condimentum
  tellus, in consectetur arcu nisl id ligula. Etiam viverra non lectus ac
  vulputate. Etiam auctor sodales aliquam. Nullam accumsan eu sapien ac
  pharetra. Vestibulum ac enim imperdiet, vulputate arcu auctor, tempus nulla.
  Quisque aliquam eget purus quis placerat. Suspendisse ut nisl vitae ipsum
  tempus mattis. Vestibulum ac magna mi.
</p>

<p class="paragraph paragraph-01-regular">
  Proin bibendum egestas interdum. Lorem ipsum dolor sit amet, consectetur
  adipiscing elit. Aenean imperdiet nisi nec interdum accumsan. Pellentesque ac
  efficitur urna. Integer vel porta tortor, eget pretium velit. Nam sit amet
  molestie sem. Vivamus ac libero nec nunc iaculis consectetur. Vivamus iaculis
  velit in purus placerat vehicula. Morbi eleifend metus metus. Maecenas mollis
  leo vel metus efficitur ornare. Nulla elit nisi, aliquet non cursus eget,
  posuere vel orci. Mauris id consectetur risus, gravida suscipit mi.
</p>

<p class="paragraph paragraph-01-regular">
  Nullam elementum felis nisl, laoreet posuere leo pharetra sit amet. Nunc porta
  commodo mi et hendrerit. Nunc venenatis euismod interdum. Nam est ex, rutrum a
  arcu eu, congue sollicitudin diam. Suspendisse mollis ex et dapibus interdum.
  Nulla velit urna, congue in augue sit amet, dictum pharetra ante. Nunc finibus
  ex id lobortis viverra. Sed maximus est sed ex rutrum congue. Nunc
  sollicitudin turpis nec mi venenatis rutrum. Nulla facilisi. Donec vitae eros
  lectus. Maecenas auctor ultricies sapien consequat ultricies.
</p>

<p class="paragraph paragraph-01-regular">
  Ut hendrerit a lorem eu lacinia. Praesent consectetur ligula dui, ac sodales
  arcu bibendum et. Curabitur non porta velit. Proin id turpis accumsan, gravida
  est nec, pretium nibh. Vivamus ut convallis risus, ac facilisis felis. Proin
  laoreet est enim, sit amet ornare justo fringilla ut. Duis varius nibh a quam
  luctus pretium. Curabitur vel lectus libero. Nam vitae ex in nulla fringilla
  bibendum at a mauris. Etiam auctor velit dignissim nulla venenatis vestibulum.
  Fusce facilisis elementum magna, at hendrerit lacus ultricies nec.
  Pellentesque semper ullamcorper metus vitae efficitur. Ut urna erat, posuere
  quis imperdiet id, pulvinar id justo. Quisque at nunc purus. Quisque elementum
  magna ut pulvinar blandit.
</p>

<p class="paragraph paragraph-01-regular">
  Curabitur a eros egestas, elementum mauris at, tincidunt arcu. Ut eu risus
  justo. Aenean pretium neque quis dolor venenatis, a porttitor felis vehicula.
  Vivamus ultricies, metus sed imperdiet luctus, dolor dolor convallis nisl, nec
  pellentesque est mauris in nunc. Donec eleifend arcu quis sapien accumsan
  fermentum. Ut elementum tincidunt nulla, sit amet bibendum libero blandit in.
  Nunc consectetur nulla eleifend egestas tempor. Mauris sodales viverra
  tincidunt. Nam pellentesque leo eget ipsum convallis semper. Nam et augue
  ullamcorper, egestas lorem in, efficitur magna. Interdum et malesuada fames ac
  ante ipsum primis in faucibus. Class aptent taciti sociosqu ad litora torquent
  per conubia nostra, per inceptos himenaeos. Maecenas sit amet mauris eu quam
  ornare finibus quis id dolor. Fusce ac enim at diam efficitur fermentum.
</p>
